module.exports = __webpack_public_path__ + "resources/img/img-secuve-tos-01-m.0dad6e4508e0fd32125c465ca927dcc5.png";